<div #scrollContainer class="card" [ngStyle]="{ height: height }">
    <div class="card-body" [ngClass]="bodyClass">
        <ng-content select="[cardBody]"></ng-content>
    </div>
</div>